/**
 * Labstep
 *
 * @module prosemirror/extensions
 * @desc Plugins are used to extend the behavior of the editor
 */

import { ExtensionAlignment } from 'labstep-web/prosemirror/extensions/alignment';
import { ExtensionCursor } from 'labstep-web/prosemirror/extensions/cursor';
import { ExtensionHistory } from 'labstep-web/prosemirror/extensions/history';
import { ExtensionKeymap } from 'labstep-web/prosemirror/extensions/keymap';
import { ExtensionReferencing } from 'labstep-web/prosemirror/extensions/referencing';
import { ExtensionCommands } from 'labstep-web/prosemirror/extensions/slash';
import { baseKeymap } from 'prosemirror-commands';
import { keymap } from 'prosemirror-keymap';
import type { Plugin } from 'prosemirror-state';
import editablePlugin from './editable/plugin';
import expandedPlugin from './expanded/plugin';
import loaderPlugin from './loader/plugin';
import placeholderPlugin from './placeholder/plugin';
import sanitizationPlugin from './sanitization/plugin';
export const extensions = [
  ExtensionAlignment,
  ExtensionHistory,
  ExtensionCursor,
  ExtensionKeymap,
];

export const getSuggestionPlugins = () => [
  ...(ExtensionReferencing.plugins || []),
  ...(ExtensionCommands.plugins || []),
  loaderPlugin,
  keymap(ExtensionReferencing.keymap || {}),
  keymap(ExtensionCommands.keymap || {}),
];

export const getExtensionsPlugins = () => {
  const extensionsKeymap = extensions
    .filter((extension) => extension.keymap)
    .reduce<Plugin[]>(
      (result, extension) => [...result, keymap(extension.keymap!)],
      [],
    );

  const extensionsPlugins = extensions
    .filter((extension) => extension.plugins)
    .reduce<Plugin[]>(
      (result, extension) => [...result, ...extension.plugins!],
      [],
    );

  return [
    ...extensionsKeymap,
    ...extensionsPlugins,
    expandedPlugin,
    editablePlugin,
    sanitizationPlugin,
    placeholderPlugin,
    keymap(baseKeymap),
  ];
};
